import { axiosInstance } from '@/api/axiosInstance';

// Re-exported for existing call sites; the implementation lives in its own
// axios-free module so edge-safe code (apiRoutes → middleware) can import
// it without dragging axiosInstance into the Edge Runtime bundle.
export { buildQuery } from '@/api/buildQuery';

/**
 * Generic GET helper: fetch a URL via the project's configured axios
 * instance and resolve to the response body. Wraps the ubiquitous
 * `(await axiosInstance().get<T>(url)).data` pattern.
 *
 * For requests that need a build-time memcache key, pass `cacheKey` —
 * it maps to `axiosInstance(cacheKey)`, which keys the in-memory cache
 * so SSG passes don't re-fetch the same payload per page.
 */
export const get = <T>(url: string, cacheKey?: string): Promise<T> => (
  axiosInstance(cacheKey).get<T>(url).then((r) => r.data)
);
